import React from "react";
import { Form } from "react-bootstrap";

const InputComponent = (props) => {
  return (
    <>
      <Form.Label htmlFor={props.id}>
        {props.controlLabel}
        {props.required && "*"}
      </Form.Label>
      <Form.Control
        rows={props.rows}
        as={props.as}
        disabled={props.disabled}
        style={{ borderColor: props.style, marginBottom: "16px" }}
        readOnly={props.readOnly}
        placeholder={props.placeholder}
        pattern={props.pattern}
        minLength={props.minLength}
        maxLength={props.maxLength}
        id={props.id}
        min={props.min}
        max={props.max}
        value={props.value}
        name={props.name}
        onChange={(e) => props.onChange(e, props.objData)}
        onKeyPress={props.onKeyPress}
        type={props.type}
        className={props.className}
        onClick={props.onClick}
        key={props.key}
        title={props.title}
      ></Form.Control>
    </>
  );
};

export default InputComponent;
